import { IAppointment } from '@sondermind/data-access/appointments';
import { IProvider } from '@sondermind/data-access/client-portal-referrals';
import { IProviderSearch } from '@sondermind/data-access/public-facing/provider-directory';
import { ISessionRequestPreferences } from '@sondermind/utilities/models-scheduling';

export enum BookingStates {
  INITIAL = 'INITIAL',
  INITIAL_WITHOUT_TIMESLOTS = 'INITIAL_WITHOUT_TIMESLOTS',
  NEW_CLIENT_NO_TIMESLOTS = 'NEW_CLIENT_NO_TIMESLOTS',
  EXISTING_CLIENT_NO_TIMESLOTS = 'EXISTING_CLIENT_NO_TIMESLOTS',
  ALREADY_PROPOSED_TIME = 'ALREADY_PROPOSED_TIME',
  LOADING = 'LOADING',
  CONFIRMED = 'CONFIRMED',
  REQUESTED = 'REQUESTED',
  ADDED_TO_MATCHES = 'ADDED_TO_MATCHES',
  RESCHEDULE = 'RESCHEDULE',
  CANCELLING = 'CANCELLING',
  ERROR = 'ERROR'
}

export enum BookingFlow {
  EXISTING_CLIENT = 'EXISTING_CLIENT', // Existing client with referral member - uses direct scheduling API
  NEW_CLIENT = 'NEW_CLIENT' // New client - uses quick checkout API
}

type DirectBookingBaseWithFlow = {
  providerPreview: IProvider | IProviderSearch;
} & (
  | { bookingFlow: BookingFlow.EXISTING_CLIENT; clientReferralMemberId: number; }
  | { bookingFlow: BookingFlow.NEW_CLIENT; clientReferralMemberId?: never; }
);

// Reschedule and Cancel can only be used with EXISTING_CLIENT flow
type DirectBookingBaseExistingClient = {
  providerPreview: IProvider | IProviderSearch;
  bookingFlow: BookingFlow.EXISTING_CLIENT;
  clientReferralMemberId: number;
};

// If bookingState is RESCHEDULE or CANCELLING, must be existing client and appointment is required
// If bookingState is INITIAL_WITHOUT_TIMESLOTS, appointment and slot are optional
// Otherwise, slot is required
export type DirectBookingData =
  | (DirectBookingBaseExistingClient & {
    bookingState: BookingStates.RESCHEDULE | BookingStates.CANCELLING;
    appointment: IAppointment;
    slot?: ISessionRequestPreferences;
  })
  | (DirectBookingBaseWithFlow & {
    bookingState?: Exclude<BookingStates, BookingStates.RESCHEDULE | BookingStates.CANCELLING>;
    appointment?: IAppointment;
    slot: ISessionRequestPreferences;
  })
  | (DirectBookingBaseWithFlow & {
    bookingState: BookingStates.INITIAL_WITHOUT_TIMESLOTS;
    appointment?: IAppointment;
    slot?: ISessionRequestPreferences;
  });

export type DirectBookingResult = {
  bookingState: BookingStates;
  message: string;
  success: boolean;
};
